// Fetch Request
import fetch from '../../../core/fetch';
import showToaster from '../../../helpers/toasterMessages/showToaster';
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';

async function submit(values, dispatch) {

  const isRestrict = await dispatch(demoRestriction({}));
  if (isRestrict) return;

  const query = `
    query(
    $id: Int,
    $minPrice: Float,
    $maxPrice: Float,
    $priceRangeCurrency: String,
    ){
      updateSearchSettings(
          id: $id,
          minPrice: $minPrice,
          maxPrice: $maxPrice,
          priceRangeCurrency: $priceRangeCurrency,
      ) {
          status
      }
    }
  `;

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: query,
      variables: {
        id: values?.id,
        minPrice: parseFloat(values?.minPrice),
        maxPrice: parseFloat(values?.maxPrice),
        priceRangeCurrency: values?.priceRangeCurrency
      }
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();

  if (data?.updateSearchSettings?.status === "success") {
    showToaster({ messageId: 'searchSettingsUpdate', toasterType: 'success' })
  } else {
    showToaster({ messageId: 'searchSettingsUpdateFailed', toasterType: 'error' })
  }

}

export default submit;
